import { render, staticRenderFns } from "./planList.vue?vue&type=template&id=351820e5&scoped=true"
import script from "./planList.vue?vue&type=script&lang=js"
export * from "./planList.vue?vue&type=script&lang=js"
import style0 from "./planList.vue?vue&type=style&index=0&id=351820e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351820e5",
  null
  
)

export default component.exports